import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import { ApplicationState, BoundActionCreators, bindThunkActionCreators } from '../../store';
import * as ProgramsListStore from '../../store/ProgramsListStore';
import * as ProjectsListStore from '../../store/ProjectsListStore';
import * as Notifications from "../../store/NotificationsStore";
import { IContainerSectionInfo, LayoutableSectionsContainer } from '../common/sectionsControl/SectionsContainer';
import * as Metadata from '../../entities/Metadata';
import { Dictionary, EntityType, Impact, StatusCategory, UpdateContext, IInsightsData, IWarning, IWithName, IExtensibleEntity, entityTypeLabelMap } from "../../entities/common";
import {
    IKeyDateAttrs, buildActions, buildKeyDateActions, ISubentity,
    buildRiskActions, buildActionItemActions, buildKeyDecisionActions, buildChangeRequestActions, buildIssuesActions
} from "../../entities/Subentities";
import * as ProjectsControl from "../common/sectionsControl/uiControls/ProjectsControl";
import * as StrategicAlignmentControl from '../common/sectionsControl/uiControls/StrategicAlignmentControl';
import * as ProgramSummaryControl from '../common/sectionsControl/uiControls/ProgramSummaryControl';
import * as StatusesControl from '../common/sectionsControl/uiControls/StatusesControl';
import * as KeyDatesControl from '../common/sectionsControl/uiControls/KeyDatesControl';
import * as RisksControl from '../common/sectionsControl/uiControls/RisksControl';
import * as ActionItemsControl from '../common/sectionsControl/uiControls/ActionItemsControl';
import * as KeyDecisionsControl from '../common/sectionsControl/uiControls/KeyDecisionsControl';
import * as ResourcePlanControl from '../common/sectionsControl/uiControls/ResourcePlanControl';
import * as EmbeddedContentControl from '../common/sectionsControl/uiControls/EmbeddedContentControl';
import * as ChangeRequestsControl from '../common/sectionsControl/uiControls/ChangeRequestsControl';
import * as IssuesControl from '../common/sectionsControl/uiControls/IssuesControl';
import { DetailsSpinner } from "../common/Spinner";
import { Reporting, ReportNav } from "../utils/reporting";
import * as LayoutsStore from '../../store/layouts';
import * as WarningsTypeMapsStore from "../../store/warningsTypeMapsStore";
import { EntitySectionWarning } from "../common/warnings/EntitySectionWarning";
import { warningService } from '../../store/services/warningService';
import { StatusCalculationTypes, Insights, TenantState, Subscription, PPMFeatures } from '../../store/Tenant';
import { CalendarDataSet } from '../../store/calendar/common';
import { nameof } from '../../store/services/metadataService';
import { ViewTypeViews, buildViewTypeHeaderRender, buildViewTypeSelect, withViewType } from '../common/ViewTypeSelect';
import AccessRequestConfirmationPanel from '../common/AccessRequestConfirmationPanel';
import { UserState, isInReadonlyMode } from '../../store/User';
import SubEntitySelectionPanel, { selectedToParentMap } from '../portfolio/SubEntitySelectionPanel';
import { ViewService } from '../../services/ViewService';
import { ImportedFromFakeField } from '../views/list/columns/subentity/ImportedFrom';
import { get } from '../../fetch-interceptor';
import ExternalEpmConnectControl from './ExternalEpmConnectControl';
import { IControlConfiguration } from '../common/interfaces/ISectionUIControlProps';
import { Views } from '../../store/services/viewSaver';
import * as StatusDescriptorFactory from '../../entities/StatusDescriptorFactory';
import { IFinancialsConfiguration } from '../common/FinancialsContent';
import { buildIWithBenefitsCustomRenders, buildIWithBenefitsValidators, rendersBuilder, validators } from '../field/Fields';
import ProgramHeader from './ProgramHeader';
import { buildTimelineItem } from './timeline';
import { renderMarkerTooltipContent, renderSegmentContent } from '../portfolio/commonTimeline';
import { Field } from '../../entities/Metadata';
import { arraysEqual } from '../utils/common';
import { withLinkedRoadmapSettings } from '../common/sectionsControl/uiControls/LinkedRoadmapControl';
import { buildReadOnlyStatusFieldsNames, IFieldsAreaConfiguration } from '../common/sectionsControl/uiControls/fieldsArea/common';

type ActionProps = {
    programsActions: BoundActionCreators<typeof ProgramsListStore.actionCreators>;
    projectsActions: typeof ProjectsListStore.actionCreators;
    notificationsActions: typeof Notifications.actionCreators;
    layoutsActions: ReturnType<typeof LayoutsStore.actionCreators.forEntity>;
    warningsTypeMapsActions: typeof WarningsTypeMapsStore.actionCreators;
};
type StateProps = {
    tenant: TenantState;
    user: UserState;
    entity?: ProgramsListStore.Program;
    warnings: IWarning[];
    isLoading: boolean;
    isUpdatingSections: boolean;
    layouts: LayoutsStore.LayoutsState;
    programReports: ReportNav[];
    warningsTypeMap: WarningsTypeMapsStore.EntityWarningsTypeMap;
    sectionWarningsTypeMap: Dictionary<string[]>;
    insights: Insights;
    projectFields: Field[];
    programFields: Field[];
    keyDateFields: Field[];
    riskFields: Field[];
    changeRequestFields: Metadata.Field[];
    issueFields: Metadata.Field[];
    keyDecisionsFields: Metadata.Field[];
    actionItemsFields: Metadata.Field[];
    isReadonlyMode: boolean;
    projects: ProjectsListStore.ProjectInfo[];
    calendar: CalendarDataSet;
};
type ProgramDetailsProps =
    StateProps
    & ActionProps
    & RouteComponentProps<{ id: string }>;

type ProgramDetailsState = {
    isCofigurationPanelOpen: boolean;
    shareWith?: string;
}
interface IConfiguration extends Dictionary<IControlConfiguration> {
    FieldsArea: IFieldsAreaConfiguration;
    ProjectsControl: ProjectsControl.IConfiguration;
    KeyDatesControl: KeyDatesControl.IConfiguration;
    ActionItemsControl: ActionItemsControl.IConfiguration;
    KeyDecisionsControl: KeyDecisionsControl.IConfiguration;
    ProgramSummaryControl: ProgramSummaryControl.IConfiguration;
    BudgetControl: IFinancialsConfiguration;
    BenefitsControl: IFinancialsConfiguration;
    StatusesControl: StatusesControl.IConfiguration;
    StrategicAlignmentControl: StrategicAlignmentControl.IConfiguration;
    RisksControl: RisksControl.IConfiguration;
    ResourcePlanControl: ResourcePlanControl.IConfiguration;
    EmbeddedContentControl: EmbeddedContentControl.IConfiguration;
    ChangeRequestsControl: ChangeRequestsControl.IConfiguration;
    IssuesControl: IssuesControl.IConfiguration;
}

const entityName = EntityType.Program;
class ProgramDetails extends React.Component<ProgramDetailsProps, ProgramDetailsState> {
    constructor(props: ProgramDetailsProps) {
        super(props);
        this.state = {
            isCofigurationPanelOpen: this.props.location.state ? !!this.props.location.state.configureConnections : false,
            shareWith: new URLSearchParams(this.props.location.search).get('shareWith') ?? undefined
        };
    }
    componentWillMount() {
        this.props.warningsTypeMapsActions.loadWarningsTypeMap(entityName);
        this.props.programsActions.loadProgram(this.props.match.params.id);
    }

    componentWillReceiveProps(nextProps: ProgramDetailsProps) {
        if (nextProps.match.params.id !== this.props.match.params.id) {
            this.props.programsActions.loadProgram(nextProps.match.params.id);
        }
        if (nextProps.entity && !arraysEqual(this.props.entity?.projectIds, nextProps.entity?.projectIds)) {
            const toLoad = nextProps.entity.projectIds.filter(_ => !nextProps.projects.find(p => p.id === _));
            if (toLoad.length > 0) {
                this.props.projectsActions.getProjectsByIds(toLoad);
            }
        }
    }

    public render() {
        const { entity, warnings, isLoading, layouts, isUpdatingSections, programReports, warningsTypeMap } = this.props;
        const { shareWith } = this.state;
        return <DetailsSpinner isLoading={isLoading}>
            {entity && <ProgramHeader
                entity={entity}
                warnings={warnings}
                warningsTypeMap={warningsTypeMap?.common}
                actions={{
                    updateSettings: (updates) => this.props.programsActions.updateSettings(entity.id, updates),
                    openConfigurationPanel: this.openConfigurationPanel,
                    updateImage: this.updateImage,
                    removeImage: this.removeImage,
                    layoutActions: {
                        viewLayout: this.viewLayout,
                        applyLayout: this.applyLayout,
                        updateEntityLayout: this.updateDefaultLayout,
                        updateEntityPinnedViews: this.updatePinnedViews,
                        saveLayout: this.saveLayout,
                        deleteLayout: this.deleteLayout
                    },
                    removeProgram: this.removeProgram,
                    updateInsights: this.updateInsights,
                }}
            />}
            {entity && entity.sections &&
                <LayoutableSectionsContainer
                    key="sections"
                    entity={entity}
                    entityType={EntityType.Program}
                    warnings={warnings}
                    onHeaderMiddleRender={this._onSectionHeaderMiddlePartRender}
                    reporting={{ reports: programReports, onClick: this._onReportClick }}
                    layouts={layouts}
                    isUpdatingSections={isUpdatingSections}
                    controlsConfig={this._buildControlsConfigurations()}
                />}
            {entity && this.state.isCofigurationPanelOpen &&
                <ExternalEpmConnectControl
                    entity={entity}
                    onDismiss={() => {
                        this.setState({ isCofigurationPanelOpen: false });
                        this.props.history.replace({ ...this.props.location, state: {} });
                    }}
                />
            }
            {
                entity && shareWith &&
                <AccessRequestConfirmationPanel
                    entity={entity}
                    entityType={EntityType.Program}
                    entityTypeLabel="Program"
                    userId={shareWith}
                    layouts={layouts}
                    onDismiss={() => {
                        this.setState({ shareWith: undefined });
                        const query = new URLSearchParams(this.props.location.search);
                        if (query.has('shareWith')) {
                            query.delete('shareWith');
                            this.props.history.replace({ search: query.toString() });
                        }
                    }}
                />
            }
        </DetailsSpinner>;
    }

    private _buildControlsConfigurations = (): IConfiguration => {
        const { entity, programsActions, layouts, user, warningsTypeMap, insights, isReadonlyMode, projects, programFields, projectFields, keyDateFields } = this.props;
        const analyticsProps = { user: user, parentType: EntityType.Program };

        const { entityId, entityActions, actions } = buildActions(entity!.id, isReadonlyMode, analyticsProps, layouts, programsActions, programsActions.loadProgram);
        const targetedwarningsTypeMap = warningsTypeMap.targeted;
        return {
            ['TimelineControl']: {
                datacontext: {
                    timeline: {
                        item: buildTimelineItem(entity!, projects, programFields, projectFields, keyDateFields),
                        displayToday: true,
                        startDate: entity!.attributes.StartDate,
                        finishDate: entity!.attributes.FinishDate,
                        renderSegmentContent: renderSegmentContent,
                        renderMarkerTooltipContent: renderMarkerTooltipContent
                    }
                },
            },
            ["FieldsArea"]: {
                editProps: {
                    customFieldValidator: { ...validators, ...buildIWithBenefitsValidators() },
                    elementCustomRender: { ...rendersBuilder(), ...buildIWithBenefitsCustomRenders() },
                },
                datacontext: {
                    entityId,
                    entityType: EntityType.Program,
                    readOnlyFields: buildReadOnlyStatusFieldsNames(insights.program.statusCalculation,
                        ProgramsListStore.statuses, !entity?.insights.statusCalculationDisabled),
                    warningsTypeMap: targetedwarningsTypeMap["Details"] && targetedwarningsTypeMap["Details"]["FieldsArea"]
                },
                actions: {
                    ...entityActions,
                    onEditComplete: this.onEditComplete,
                }
            },
            ["StatusesControl"]: {
                ...buildViewTypeSelect(ViewTypeViews.StatusesControl),
                datacontext: {
                    entityId,
                    entityType: EntityType.Program,
                    statusCalculation: insights.program,
                    statuses: ProgramsListStore.statuses,
                    warningsTypeMap: targetedwarningsTypeMap["Statuses"] && targetedwarningsTypeMap["Statuses"]["StatusesControl"]
                },
                actions: {
                    ...entityActions,
                    onEditComplete: this.onEditCompleteMultipleAttrs,
                    resetStatus: this.resetStatus,
                    deleteStatusHistory: this.deleteHistory,
                    loadStatusHistory: this.loadHistory,
                }
            },
            ["ProgramSummaryControl"]: { },
            ["KeyDatesControl"]: {
                settingsBuilder: KeyDatesControl.settingsBuilder,
                headerRender: buildViewTypeHeaderRender(ViewTypeViews.KeyDatesControl),
                datacontext: {
                    theOnlyEditableFieldsForLinkedEntities: [nameof<IKeyDateAttrs>("ShowOnTimeline")],
                    fakeFields: [ImportedFromFakeField],
                    readOnlyFields: this.isKeyDatesStatusCalculationAuto()
                        ? [nameof<IKeyDateAttrs>("Status")]
                        : [],
                    calendar: this.props.calendar
                },
                actions: buildKeyDateActions(entityId, analyticsProps, actions, programsActions, keyDateFields, this._renderKeyDateImport())
            },
            ["RisksControl"]: {
                settingsBuilder: withViewType(Views.List),
                datacontext: {
                    fakeFields: [ImportedFromFakeField],
                    theOnlyEditableFieldsForLinkedEntities: []
                },
                actions: buildRiskActions(entityId, analyticsProps, actions, programsActions, this._renderRiskImport())
            },
            ['ProjectsControl']: {
                ...buildViewTypeSelect(ViewTypeViews.ProjectsControl),
                actions: {
                    addProjects: this.addProjects,
                    removeProjects: this.removeProjects,
                    updateUIControl: entityActions.updateUIControl
                }
            },
            ["BudgetControl"]: {
                actions: { updateCalculation: this.updateCalculation }
            },
            ["BenefitsControl"]: {
                actions: { updateCalculation: this.updateCalculation }
            },
            ["StrategicAlignmentControl"]: {
                actions: {
                    updatePriorityAlignment: this.updatePriorityAlignment,
                    recalculateAlignmentScore: this.recalculateAlignmentScore,
                }
            },
            ["ActionItemsControl"]: {
                settingsBuilder: withViewType(Views.List),
                actions: buildActionItemActions(entityId, analyticsProps, actions, programsActions, this._renderActionItemsImport()),
                datacontext: {
                    fakeFields: [ImportedFromFakeField],
                    theOnlyEditableFieldsForLinkedEntities: []
                },
            },
            ["KeyDecisionsControl"]: {
                settingsBuilder: withViewType(Views.List),
                actions: buildKeyDecisionActions(entityId, analyticsProps, actions, programsActions, this._renderKeyDecisionsImport()),
                datacontext: {
                    fakeFields: [ImportedFromFakeField],
                    theOnlyEditableFieldsForLinkedEntities: []
                },
            },
            ['ResourcePlanControl']: {
                ...buildViewTypeSelect(ViewTypeViews.ResourcePlanControl),
                datacontext: { entityType: EntityType.Program },
                actions: {
                    addResources: (resourceIds, timeframe) =>
                        this.props.programsActions.addResources(this.props.entity!.id, resourceIds, timeframe),
                    createResource: (name, layoutId, timeframe, auto, startDate, finishDate) =>
                        this.props.programsActions.createResourceAndAdd(entityId, name, layoutId, timeframe, auto, startDate, finishDate),
                    replaceResources: (prev, next, keepRate, sumUpPlanHours, sumUpActualHours, timeframe, costRateTableId) =>
                        this.props.programsActions.replaceResource(entityId, prev, next, keepRate, sumUpPlanHours, timeframe, sumUpActualHours, costRateTableId),
                    removeResources: (ids, timeframe) => this.props.programsActions.removeResources(entityId, ids, timeframe),
                    updateUIControl: entityActions.updateUIControl
                }
            },
            ['EmbeddedContentControl']: {
                datacontext: { entityType: EntityType.Program },
                helpUrl: "https://help.ppm.express/89502-ppm-express-how-to-articles/2693767-query-string-parameters-for-embedding-specific-power-bi-report-details-to-project-dashboard",
                actions: {
                    updateUiControl: entityActions.updateUIControl
                }
            },
            ['LinkedRoadmapControl']:
                withLinkedRoadmapSettings(entity, EntityType.Program, user, this.props.isReadonlyMode, entityActions.updateUIControl),
            ["ChangeRequestsControl"]: {
                settingsBuilder: withViewType(Views.List),
                actions: buildChangeRequestActions(entityId, analyticsProps, actions, this.props.programsActions, this._renderChangeRequestsImport()),
                datacontext: {
                    fakeFields: [ImportedFromFakeField],
                    theOnlyEditableFieldsForLinkedEntities: []
                },
            },
            ["IssuesControl"]: {
                settingsBuilder: withViewType(Views.List),
                actions: buildIssuesActions(entityId, analyticsProps, actions, this.props.programsActions, this._renderIssuesImport()),
                datacontext: {
                    fakeFields: [ImportedFromFakeField],
                    theOnlyEditableFieldsForLinkedEntities: []
                },
            },
        }
    }

    private _onReportClick = (report: ReportNav) => {
        Reporting.openProgramReport(this.props.history, report, this.props.entity!);
    }

    private onEditComplete = (fieldName: string, fieldValue: any): void => {
        if (!fieldName) {
            return;
        }

        this.props.programsActions.updateAttributes(this.props.entity!.id, { [fieldName]: fieldValue });
    }

    private onEditCompleteMultipleAttrs = (attrs: Dictionary<string | number | undefined>, context: Dictionary<UpdateContext>): void => {
        this.props.programsActions.updateAttributes(this.props.entity!.id, attrs, context);
    }

    private deleteHistory = (attributeName: string, id: string | undefined): void => {
        this.props.programsActions.deleteHistory(this.props.entity!.id, attributeName, id);
    }

    private loadHistory = (attributeName?: string) => {
        this.props.programsActions.loadHistory(this.props.entity!.id, attributeName);
    }

    private resetStatus = (statusAttributeName: string): void => {
        this.props.programsActions.resetProgramStatus(this.props.entity!.id, statusAttributeName);
    }

    private updateInsights = (data: Partial<IInsightsData>): void => {
        this.props.programsActions.updateInsights(this.props.entity!.id, data);
        this.props.notificationsActions.pushNotification({ message: `Autocalculation settings have been changed.` });
    }

    private addProjects = (porjectIds: string[]) => {
        this.props.programsActions.addProjects(this.props.entity!.id, porjectIds);
    }

    private removeProjects = (porjectIds: string[]) => {
        this.props.programsActions.removeProjects(this.props.entity!.id, porjectIds);
    }

    private updateImage = (logo: File) => {
        this.props.programsActions.updateImage(this.props.entity!.id, logo);
    }

    private removeImage = () => {
        this.props.programsActions.removeImage(this.props.entity!.id);
    }

    private updatePriorityAlignment = (strategicPriorityId: string, impact: Impact) => {
        this.props.programsActions.updatePriorityAlignment(this.props.entity!.id, strategicPriorityId, impact);
    }

    private recalculateAlignmentScore = () => {
        this.props.programsActions.recalculateAlignmentScore(this.props.entity!.id);
    }

    private updateCalculation = (changes: Partial<ProgramsListStore.ProgramCalculation>) => {
        this.props.programsActions.updateCalculation(this.props.entity!.id, changes);
    }

    private isKeyDatesStatusCalculationAuto() {
        const { insights, entity } = this.props;
        return insights.keyDate.statusCalculation === StatusCalculationTypes.Auto && !entity?.insights.keyDateStatusCalculationDisabled;
      }

    private readonly _renderKeyDateImport = (): undefined | ((props: { onDismiss: () => void }) => JSX.Element) => {
        if (!Subscription.contains(this.props.tenant.subscription, PPMFeatures.SubentityRollups)) {
            return undefined;
        }
        if (this.props.entity!.projectIds.length === 0) {
            return undefined;
        }

        const { entity, projectFields, keyDateFields, programsActions } = this.props;
        return (props: { onDismiss: () => void }) =>
            <SubentityImportControl
                program={entity}
                projectFields={projectFields}

                subEntityType={EntityType.KeyDate}
                subEntityFields={keyDateFields}
                getSubentities={(ent: ProjectsListStore.ProjectInfo) => ent.keyDates}

                onDismiss={props.onDismiss}
                onSelectionComplete={(selectedMap) => programsActions.linkKeyDates(entity!.id, selectedMap)}
            />;
    }

    private readonly _renderRiskImport = (): undefined | ((props: { onDismiss: () => void }) => JSX.Element) => {
        if (!Subscription.contains(this.props.tenant.subscription, PPMFeatures.SubentityRollups)) {
            return undefined;
        }
        if (this.props.entity!.projectIds.length === 0) {
            return undefined;
        }

        const { entity, projectFields, riskFields, programsActions } = this.props;
        return (props: { onDismiss: () => void }) =>
            <SubentityImportControl
                program={entity}
                projectFields={projectFields}

                subEntityType={EntityType.Risk}
                subEntityFields={riskFields}
                getSubentities={(ent: ProjectsListStore.ProjectInfo) => ent.risks}

                onDismiss={props.onDismiss}
                onSelectionComplete={(selectedMap) => programsActions.linkRisks(entity!.id, selectedMap)}
            />;
    }

    private readonly _renderChangeRequestsImport = (): undefined | ((props: { onDismiss: () => void }) => JSX.Element) => {
        if (!Subscription.contains(this.props.tenant.subscription, PPMFeatures.SubentityRollups)) {
            return undefined;
        }
        if (this.props.entity!.projectIds.length === 0) {
            return undefined;
        }

        const { entity, projectFields, changeRequestFields, programsActions } = this.props;
        return (props: { onDismiss: () => void }) =>
            <SubentityImportControl
                program={entity}
                projectFields={projectFields}

                subEntityType={EntityType.ChangeRequest}
                subEntityFields={changeRequestFields}
                getSubentities={(ent: ProjectsListStore.ProjectInfo) => ent.changeRequests}

                onDismiss={props.onDismiss}
                onSelectionComplete={(selectedMap) => programsActions.linkChangeRequests(entity!.id, selectedMap)}
            />;
    }

    private readonly _renderIssuesImport = (): undefined | ((props: { onDismiss: () => void }) => JSX.Element) => {
        if (!Subscription.contains(this.props.tenant.subscription, PPMFeatures.SubentityRollups)) {
            return undefined;
        }
        if (this.props.entity!.projectIds.length === 0) {
            return undefined;
        }

        const { entity, projectFields, issueFields, programsActions } = this.props;
        return (props: { onDismiss: () => void }) =>
            <SubentityImportControl
                program={entity}
                projectFields={projectFields}

                subEntityType={EntityType.Issue}
                subEntityFields={issueFields}
                getSubentities={(ent: ProjectsListStore.ProjectInfo) => ent.issues}

                onDismiss={props.onDismiss}
                onSelectionComplete={(selectedMap) => programsActions.linkIssues(entity!.id, selectedMap)}
            />;
    }

    private readonly _renderKeyDecisionsImport = (): undefined | ((props: { onDismiss: () => void }) => JSX.Element) => {
        if (!Subscription.contains(this.props.tenant.subscription, PPMFeatures.SubentityRollups)) {
            return undefined;
        }
        if (this.props.entity!.projectIds.length === 0) {
            return undefined;
        }

        const { entity, projectFields, keyDecisionsFields, programsActions } = this.props;
        return (props: { onDismiss: () => void }) =>
            <SubentityImportControl
                program={entity}
                projectFields={projectFields}

                subEntityType={EntityType.KeyDecision}
                subEntityFields={keyDecisionsFields}
                getSubentities={(ent: ProjectsListStore.ProjectInfo) => ent.keyDecisions}

                onDismiss={props.onDismiss}
                onSelectionComplete={(selectedMap) => programsActions.linkKeyDecisions(entity!.id, selectedMap)}
            />;
    }

    private readonly _renderActionItemsImport = (): undefined | ((props: { onDismiss: () => void }) => JSX.Element) => {
        if (!Subscription.contains(this.props.tenant.subscription, PPMFeatures.SubentityRollups)) {
            return undefined;
        }
        if (this.props.entity!.projectIds.length === 0) {
            return undefined;
        }

        const { entity, projectFields, actionItemsFields, programsActions } = this.props;
        return (props: { onDismiss: () => void }) =>
            <SubentityImportControl
                program={entity}
                projectFields={projectFields}

                subEntityType={EntityType.ActionItem}
                subEntityFields={actionItemsFields}
                getSubentities={(ent: ProjectsListStore.ProjectInfo) => ent.actionItems}

                onDismiss={props.onDismiss}
                onSelectionComplete={(selectedMap) => programsActions.linkActionItems(entity!.id, selectedMap)}
            />;
    }

    private _onSectionHeaderMiddlePartRender = (section: IContainerSectionInfo): JSX.Element | null => {
        return (
            <EntitySectionWarning warningsTypes={this.props.sectionWarningsTypeMap[section.name]}
                warnings={this.props.warnings} />
        );
    }

    private applyLayout = (layout: Metadata.Layout) => {
        this.props.programsActions.applyLayout(this.props.entity!.id, layout.id);
        this.props.notificationsActions.pushNotification({ message: `Layout '${layout.name}' applied`, type: Notifications.NotificationType.Info });
    }

    private viewLayout = (layout?: Metadata.Layout) => {
        this.props.layoutsActions.viewLayout(layout?.id);
    }

    private updateDefaultLayout = (updates: Dictionary<Metadata.IUpdateSectionInfo>) => {
        const entity = this.props.entity!;
        if (this.props.isReadonlyMode) {
            this.props.programsActions.updateSectionsOnClient(entity, updates);
        } else {
            this.props.programsActions.updateSections(entity.id, updates);
        }
    }

    private updatePinnedViews = (pinnedViews: string[]) => {
        this.props.programsActions.updatePinnedViews(this.props.entity!.id, pinnedViews);
    }

    private deleteLayout = (layout: Metadata.Layout) => {
        this.props.layoutsActions.removeLayout(layout.id);
        this.props.notificationsActions.pushNotification({ message: `${layout.isView ? 'View' : 'Layout'} '${layout.name}' deleted`, type: Notifications.NotificationType.Info });
    }

    private saveLayout = (layoutId: string | undefined, sections: Metadata.Section[], update: Metadata.IUpdateLayoutInfo, callback?: (layoutId: string) => void) => {
        this.props.layoutsActions.saveLayout(layoutId, sections, update, callback);
        this.props.notificationsActions.pushNotification({
            message: `${update.isView ? 'View' : 'Layout'} '${update.name}' ${layoutId ? 'updated' : 'created'}`,
            type: Notifications.NotificationType.Info
        });
    }

    private removeProgram = () => {
        this.props.programsActions.removePrograms([this.props.entity!.id], true);
    }

    private openConfigurationPanel = () => {
        this.setState({ isCofigurationPanelOpen: true });
    }
}

function ensureProjectWarning(warnings: IWarning[], program: ProgramsListStore.Program, state: ApplicationState): IWarning[] {
    if (state.tenant.insights.programWarningsCalculationDisabled || program.insights.warningsCalculationDisabled) {
        return warnings;
    }

    const warning: IWarning = {
        type: "ProjectWithWarning_OverallStatusOnTrack",
        text: "At least one Project has warning. Please consider changing Program Overall Status."
    }

    if (warnings.find(_ => _.type === warning.type)) {
        return warnings;
    }

    const programFields = state.fields[EntityType.Program].allIds.map(_ => state.fields[EntityType.Program].byId[_]);
    const programOverallStatusDescriptor = StatusDescriptorFactory.createStatusDescriptorFor(EntityType.Program, programFields)!;
    if (programOverallStatusDescriptor.isInCategory(program.attributes.OverallStatus, StatusCategory.Green)) {
        for (const projectId of program.projectIds) {
            const projectInfo = state.projectsList.byId[projectId];
            if (!projectInfo?.warnings.length) {
                continue;
            }
            return [...warnings, warning];
        }
    }

    return warnings;
}

function mergeActionCreators(dispatch: any): ActionProps {
    return {
        programsActions: bindThunkActionCreators(ProgramsListStore.actionCreators, dispatch),
        projectsActions: bindActionCreators(ProjectsListStore.actionCreators, dispatch),
        notificationsActions: bindActionCreators(Notifications.actionCreators, dispatch),
        layoutsActions: bindActionCreators(LayoutsStore.actionCreators.forEntity(entityName), dispatch),
        warningsTypeMapsActions: bindActionCreators(WarningsTypeMapsStore.actionCreators, dispatch),
    }
}

export default connect(
    (state: ApplicationState, ownProp?: RouteComponentProps<{ id: string }>): StateProps => {
        const warningsTypeMap = state.warningsTypeMaps.maps[entityName] || { common: [], targeted: {} }
        const entity = state.programs.activeEntity && state.programs.activeEntity.id === ownProp!.match.params.id
            ? state.programs.activeEntity
            : undefined;
        let warnings: IWarning[] = [];
        let sectionWarningsTypeMap = {};
        if (entity?.sections) {
            warnings = ensureProjectWarning([...entity.warnings], entity, state);
            const tuple = warningService.filterByEntityConfiguration(warnings, warningsTypeMap, entity.sections);
            warnings = tuple.warnings;
            sectionWarningsTypeMap = tuple.sectionWarningsTypeMap;
        }
        const projectFields = state.fields[EntityType.Project];
        const programFields = state.fields[EntityType.Program];
        const keyDateFields = state.fields[EntityType.KeyDate];
        const riskFields = state.fields[EntityType.Risk];
        const changeRequestFields = state.fields[EntityType.ChangeRequest];
        const issueFields = state.fields[EntityType.Issue];
        const keyDecisionsFields = state.fields[EntityType.KeyDecision];
        const actionItemsFields = state.fields[EntityType.ActionItem];

        return {
            tenant: state.tenant,
            user: state.user,
            projectFields: projectFields.allIds.map(_ => projectFields.byId[_]),
            programFields: programFields.allIds.map(_ => programFields.byId[_]),
            riskFields: riskFields.allIds.map(_ => riskFields.byId[_]),
            keyDateFields: keyDateFields.allIds.map(_ => keyDateFields.byId[_]),
            changeRequestFields: changeRequestFields.allIds.map(_ => changeRequestFields.byId[_]),
            issueFields: issueFields.allIds.map(_ => issueFields.byId[_]),
            keyDecisionsFields: keyDecisionsFields.allIds.map(_ => keyDecisionsFields.byId[_]),
            actionItemsFields: actionItemsFields.allIds.map(_ => actionItemsFields.byId[_]),
            entity,
            warnings,
            warningsTypeMap,
            sectionWarningsTypeMap,
            projects: state.projectsList.allIds.map(_ => state.projectsList.byId[_]),
            calendar: state.calendars.byId[state.calendars.defaultCalendarId],
            isLoading: state.programs.isLoading || state.warningsTypeMaps.isLoading || !!state.layouts[entityName].isApplyingLayout,
            programReports: state.tenant.reporting.programReports.subPacks,
            insights: state.tenant.insights,
            isUpdatingSections: state.programs.isUpdatingSections,
            layouts: state.layouts[entityName],
            isReadonlyMode: isInReadonlyMode(state.user, state.tenant)
        };
    },
    mergeActionCreators
)(ProgramDetails);

const SubentityImportControl = (props: {
    program?: ProgramsListStore.Program,
    projectFields: Metadata.Field[],

    subEntityType: EntityType,
    subEntityFields: Metadata.Field[];
    getSubentities: (entity: IExtensibleEntity) => ISubentity[]

    onDismiss: () => void,
    onSelectionComplete: (selectionMap: Dictionary<string[]>) => void,
}): JSX.Element => {
    const _getRollupSources = () => get<{ projects: ProjectsListStore.ProjectInfo[] }>(`api/program/${props.program?.id}/rollupSources`)
        .then(data => data.projects);

    const projectNameField = React.useMemo(() => props.projectFields.find(_ => _.name === nameof<IWithName>("Name"))!, [props.projectFields]);
    const projectNameColumn = React.useMemo(() =>
        ViewService.buildColumn(projectNameField.name, { Name: projectNameField }, undefined, false, EntityType.Project, undefined, true)
        , [projectNameField]);

    const subentities = props.getSubentities(props.program!);

    return <SubEntitySelectionPanel
        multichoice
        load={_getRollupSources}
        subentityType={props.subEntityType}
        subEntityNameField={props.subEntityFields.find(_ => _.name === nameof<IWithName>("Name"))!}
        filters={{ disabledIds: subentities.filter(_ => !!_.externalId).map(_ => _.externalId!) }}
        getName={(entity: ProjectsListStore.ProjectInfo) => entity.attributes[projectNameField.name]}
        getSubentities={props.getSubentities}
        entityNameLabel={projectNameField.label}
        subentityNameLabel={`${entityTypeLabelMap[props.subEntityType].singular} Name`}
        onRenderNameColumn={(entity: ProjectsListStore.ProjectInfo) => projectNameColumn?.onRender!(entity, undefined, projectNameColumn)}
        header={{
            title: `Import ${entityTypeLabelMap[props.subEntityType].plural}`,
            description: `Select ${entityTypeLabelMap[props.subEntityType].singular?.toLowerCase()} that you want to import from related Projects to be available for viewing in current Program`
        }}
        onDismiss={props.onDismiss}
        onSelectionComplete={(selected) => props.onSelectionComplete(selectedToParentMap(selected))}
    />
}